export const readSafeJsonArray = (key) => {
    if (typeof window === 'undefined') return [];
    try {
        const raw = window.localStorage.getItem(key);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
};

export const writeSafeJsonArray = (key, items) => {
    if (typeof window === 'undefined') return;
    try {
        window.localStorage.setItem(key, JSON.stringify(items));
    } catch {}
};

export const subscribeStorageKey = (storageKey, eventName, handler) => {
    if (typeof window === 'undefined') return () => {};
    const onChange = () => handler();
    const onStorage = (e) => {
        if (e.key === storageKey) handler();
    };
    if (eventName) window.addEventListener(eventName, onChange);
    window.addEventListener('storage', onStorage);
    return () => {
        if (eventName) window.removeEventListener(eventName, onChange);
        window.removeEventListener('storage', onStorage);
    };
};
